import type { DocumentNode } from 'graphql';
import { parse } from 'graphql';

export function parseQuery(query: DocumentNode | string): DocumentNode {
	return typeof query === 'string' ? parse(query) : query;
}
